var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.onlyProjectPage)?_c('div',{staticClass:"btnChangePerspective",class:{hasPerspective: _vm.changePerspective},on:{"mousemove":_vm.getMouseValues,"mouseleave":_vm.resetMouseValues}},[_c('button',{attrs:{"type":"button","name":"button"}},[_c('span',{on:{"mousemove":_vm.getMouseValues}},[_vm._v(_vm._s(_vm.perspectiveText))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }